import { api, apiRequest } from "./api";

export type CommunicationMedium =
  | "whatsapp"
  | "email"
  | "sms"
  | "phone"
  | "push_notification"
  | "web_push_notification";

export type CommunicationStatus =
  | "pending"
  | "sent"
  | "failed"
  | "delivered"
  | "bounced";

export type CommunicationProvider =
  | "onesignal"
  | "msg91"
  | "superfone"
  | "aisensy";

export interface CommunicationRecord {
  id: string;
  patient: string;
  communication_medium: CommunicationMedium;
  communication_provider: CommunicationProvider;
  status: CommunicationStatus;
  recipient: string;
  template_id: string;
  template_name: string;
  external_id: string;
  error_code: string;
  error_message: string;
  metadata: Record<string, unknown>;
  // Phase 3 new fields
  provider_response: Record<string, unknown> | null;
  http_status_code: number | null;
  response_time_ms: number | null;
  retry_count: number;
  parent_communication: string | null;
  created_at: string;
}

export interface CommunicationListParams {
  user_id: string;
  medium?: CommunicationMedium;
  provider?: CommunicationProvider;
  status?: CommunicationStatus;
  start_date?: string;
  end_date?: string;
  page?: number;
  page_size?: number;
}

export interface CommunicationListResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: CommunicationRecord[];
}

export interface MediumByCount {
  communication_medium: CommunicationMedium;
  count: number;
}

export interface StatusByCount {
  status: CommunicationStatus;
  count: number;
}

export interface ProviderByCount {
  communication_provider: CommunicationProvider;
  count: number;
}

export interface CommunicationStats {
  user_id: string;
  total: number;
  by_medium: MediumByCount[];
  by_status: StatusByCount[];
  by_provider: ProviderByCount[];
}

export const communicationsAPI = {
  listCommunications: (
    params: CommunicationListParams
  ): Promise<CommunicationListResponse> => {
    return apiRequest(() => api.get("/patient/communications/", { params }));
  },

  getCommunicationStats: (userId: string): Promise<CommunicationStats> => {
    return apiRequest(() =>
      api.get("/patient/communications/stats/", {
        params: { user_id: userId },
      })
    );
  },

  retryCommunication: (id: string): Promise<CommunicationRecord> => {
    return apiRequest(() => api.post(`/patient/communications/${id}/retry/`));
  },
};
